<template>
    <div>
        <div class="content-header">
             <h1 class="content-title">
                 待办任务
             </h1>
            <ol class="breadcrumb"  v-if="!isHomePage">
	        <li><a href="#"><i class="fa fa-dashboard"></i> &nbsp; 首页</a></li>
	        <li class="active">待办任务</li>
	      </ol>
         </div>
         <div class="content">
             <div class="box-defalut box">
                 <div class="box-body">
                     <ul class="nav nav-pills carFormNav">
                         
                        <!-- <li v-for='(tab,index) in tabs' :key='index'role="presentation"  :class='{"active":tab.show}'><a href="javascript:;" @click="(e) => { return changeTabs(e, tab.component,tabs)}">{{tab.name}}</a></li> -->
                        <el-row>
                            <el-badge :value="tab.total" class="item"  v-for='(tab,index) in tabs' :key='index' style="marginRight:20px;">
                                 <el-button  @click="(e) => { return changeTabs(e, tab.component,tabs)}" :autofocus='tab.show' :style="[tab.show?but_active:'',but_style]">{{tab.name}}</el-button>
                            </el-badge>
                        </el-row>
                     </ul>
                 </div>
             </div>
             <!-- 车贷 -->
             <div class="box-defalut box" v-show='tab.show' v-for='(tab,index) in tabs' :key='index'>
                 <component :is="tab.component" @getTotal='(val)=>{return getTotal(val,tab)}' :isHomePageSub = "isHomePage"></component>
             </div>
         </div>
    </div>
</template>


<script>
import carLoan from './todo';
import refund from './refundOrder';
import settle from './settleOrder';
import charge from './chargeOrder';
    export default{
        props:['isHomePage'],
        data () {
            return {
                activeName:'first',
                carLoan:'carLoan',
                but_active:{
                  backgroundColor:"#337AB7",
                  color:"blanchedalmond"
                },
                but_style:{
                  padding:'15px 20px 15px',
                  fontSize:'16px'
                },
                tabs:[{'name':'车贷',show:true,component:'carLoan',total:0},{'name':'扣款',show:false,component:'charge',total:0},{'name':'退款',show:false,component:'refund',total:0},{'name':'结清',show:false,component:'settle',total:0}],
            
            }
        },
        methods: {
            changeTabs(e,componentName,tabs){
               this.carLoan=componentName;
               tabs.forEach((tab)=>{
                   if(tab.component!==componentName)tab.show=false;
                   else tab.show=true;
               })
            },
            getTotal(val,item){
               this.$set(item,'total',val)
            }
        },
        mounted(){
            if(this.isHomePage==true){
                this.tabs=[{'name':'放款',show:true,component:'carLoan',total:0},{'name':'扣款',show:false,component:'charge',total:0},{'name':'退款',show:false,component:'refund',total:0},{'name':'结清',show:false,component:'settle',total:0}]
            }
        },
        components:{carLoan,refund,settle,charge},
    }
</script>

<style>
.but_active{
    background-color: #20A0FF;
    color: blanchedalmond;
}
</style>




// WEBPACK FOOTER //
// waitTask.vue?fce82a46